export const ROWS_PER_PAGE = [2, 10, 25, 50, 100];
